const EXTENSION_ICON_MAP: Record<string, string> = {
  JPEG: 'JPG',
};

const DEFAULT_ICON = 'FILE';

export const getFileIconName = (fileName: string): string => {
  const ext = fileName.split('.').pop()?.toUpperCase() || '';
  return EXTENSION_ICON_MAP[ext] ?? (ext || DEFAULT_ICON);
};
